import { Link, useLocation } from "react-router-dom";

const items = [
  { label: "首页", icon: "ri-home-5-line", to: "/" },
  { label: "电影", icon: "ri-film-line", to: "/category/movie" },
  { label: "电视剧", icon: "ri-tv-2-line", to: "/category/tv" },
  { label: "资讯", icon: "ri-newspaper-line", to: "/news" },
  { label: "搜索", icon: "ri-search-line", to: "/search" },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-primary-950 border-t border-primary-900">
      <div className="grid grid-cols-5">
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`flex flex-col items-center justify-center py-2 gap-0.5 cursor-pointer ${
              isActive(item.to) ? "text-accent-400" : "text-background-400"
            }`}
          >
            <i className={`${item.icon} text-xl`}></i>
            <span className="text-[11px] font-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}